export const PaginationInfoFields = {
  TotalPages: "cantPages",
  CurrentPage: "actualPage",
  TotalRecords: "cantRecords",
  PageSize: "pageSize",
} as const;

/**
 * Modelo para la información de paginación, proveniente de la API.
 */
export type PaginationInfo = {
  [PaginationInfoFields.TotalPages]: number;
  [PaginationInfoFields.CurrentPage]: number;
  [PaginationInfoFields.TotalRecords]: number;
  [PaginationInfoFields.PageSize]: number;
};

export const PaginationRequestFields = {
  CurrentPage: "actualPage",
  PageSize: "pageSize",
  OrderBy: "OrderBy",
} as const;

export type PaginationRequest = {
  [PaginationRequestFields.CurrentPage]: number;
  [PaginationRequestFields.PageSize]: number;
};
